import { createAction, props } from '@ngrx/store';
import { Order as Entity } from './order.model';
import { IPage, IResultWithPageInfo } from '../app-store.interfaces';

export const loadPage = createAction(
    '[Order] Load Paginated Orders',
    props<{ page: IPage; correlationId?: string }>()
);

export const loadPageSuccess = createAction(
    '[Order] Load Paginated Orders Success',
    props<{ resultWithPageInfo: IResultWithPageInfo<Entity>; correlationId?: string }>()
);

export const loadPageFailure = createAction(
    '[Order] Load Paginated Orders Failure',
    props<{ error: Error; correlationId?: string }>()
);

export const loadSingle = createAction(
    '[Order] Load Single Order',
    props<{ entityId: number; correlationId?: string }>()
);

export const loadSingleSuccess = createAction(
    '[Order] Load Single Order Success',
    props<{ entity: Entity; correlationId?: string }>()
);

export const loadSingleFailure = createAction(
    '[Order] Load Single Order Failure',
    props<{ error: Error; correlationId?: string }>()
);

export const setCurrentEntityId = createAction(
    '[Order] Set Current Entity Id',
    props<{ entityId: number }>()
);

export const deselectCurrent = createAction('[Order] Deselect Current Entity');

export const OrderActions = {
    loadPage,
    loadPageSuccess,
    loadPageFailure,
    loadSingle,
    loadSingleSuccess,
    loadSingleFailure,
    setCurrentEntityId,
    deselectCurrent,
};
